export const tiers = [
  {
    name: 'Starter',
    href: '#',
    priceMonthly: process.env.REACT_APP_STARTER_PRICE,
    description: 'Perfect for developers starting out with web data extraction.',
    includedFeatures: [
      '100,000 credits / month',
      '50 concurrent requests',
      'Shared Queue',
      'Email support'
    ],
    productId: process.env.REACT_APP_STARTER_ID
  },
  {
    name: 'Standard',
    href: '#',
    priceMonthly: process.env.REACT_APP_STANDARD_PRICE,
    description: 'A plan for businesses looking to extract data at scale',
    includedFeatures: [
      '300,000 credits / month',
      '100 concurrent requests',
      'Shared Queue',
      'Priority Email support'
    ],
    productId: process.env.REACT_APP_STANDARD_ID
  },
  {
    name: 'Professional',
    href: '#',
    priceMonthly: process.env.REACT_APP_PROFESSIONAL_PRICE,
    description: 'For businesses looking to supercharge research activities',
    includedFeatures: [
      '750,000 credits / month',
      '200 concurrent requests',
      'Shared Queue',
      'Priority Email support',
      'Team Management'
    ],
    productId: process.env.REACT_APP_PROFESSIONAL_ID
  },
  {
    name: 'Enterprise',
    href: '#',
    priceMonthly: process.env.REACT_APP_ENTERPRISE_PRICE,
    description: 'A plan for enterprises looking to extract data at scale',
    includedFeatures: [
      '2,000,000 credits / month',
      '350 concurrent requests',
      'Dedicated Queue',
      'Priority Email support',
      'Team Management',
      'Dedicated Account Manager'
    ],
    productId: process.env.REACT_APP_ENTERPRISE_ID
  },
  {
    name: 'Enterprise Plus',
    href: '#',
    priceMonthly: process.env.REACT_APP_ENTERPRISE_PLUS_PRICE,
    description: 'Advanced enterprise solution for high-volume data operations',
    includedFeatures: [
      '6,000,000 credits / month',
      '600 concurrent requests',
      'Dedicated Queue',
      'Priority Email support',
      'Team Management',
      'Dedicated Account Manager',
      'Custom API limits'
    ],
    productId: process.env.REACT_APP_ENTERPRISE_PLUS_ID
  },
  {
    name: 'Enterprise Scale',
    href: '#',
    priceMonthly: process.env.REACT_APP_ENTERPRISE_SCALE_PRICE,
    description: 'Ultimate enterprise solution for massive data extraction needs',
    includedFeatures: [
      '10,000,000 credits / month',
      '1000 concurrent requests',
      'Dedicated Queue',
      'Priority Email support',
      'Team Management',
      'Dedicated Account Manager',
      'Custom API limits',
      'White-glove onboarding'
    ],
    productId: process.env.REACT_APP_ENTERPRISE_SCALE_ID
  }
];
